shvenergy.servicemenu = (function ($) {
	"use strict";

	function init() {

		var allDropdowns = $(".js-servicemenu-dropdown");

		allDropdowns.each(function () {

			var dropdown = $(this);
			var otherdropdowns = allDropdowns.not(dropdown);

			var but = dropdown.find("button");

			but.on("click", function () {

				var aria = but.attr("aria-expanded") === "true" ? "false" : "true";

				but.toggleClass("selected").attr("aria-expanded", aria);
				otherdropdowns.find("button").removeClass("selected");
			});

		});

		$(document).on("click", function (e) {
			if ($(e.target).closest(".js-servicemenu-dropdown").length === 0) {
				allDropdowns.find("button").removeClass("selected").attr("aria-expanded", "false");
			}
		});
	}

	init();
})(jQuery);